// The canonical Exit Reason options for a student who has left the program.
// Shared by the End Enrollment dialog, the student file (Demographics), and the
// Former Students section on the Referral Trends dashboard so all three stay in
// sync. "Other" prompts staff to type the specific reason (exit_reason_other).
export const EXIT_REASONS = [
  "Graduated",
  "Disenrolled",
  "Crisis",
  "Went back to sending school",
  "Transfer to Tech",
  "Deceased",
  "Residential",
  "DCF placement / change of custody",
  "Did not attend or engage",
  "Student school safety issue",
  "Did not meet graduation requirements",
  "Other",
];

export const OTHER_EXIT_REASON = "Other";

// Human-readable label for a stored exit reason (expands "Other" to the typed text).
export const exitReasonLabel = (exitReason, exitReasonOther) => {
  const er = (exitReason || "").trim();
  if (!er) return "";
  if (er === OTHER_EXIT_REASON) return (exitReasonOther || "").trim() || "Other";
  return er;
};
